import { css } from 'styled-components';
import { TableProps } from './models';

export const Table = css<TableProps<object>>(({ theme }) => {
  return css`
    display: table;
    width: 100%;
    border-collapse: collapse;
    flex-direction: column;
  `;
});

export const TableRow = css(({ theme }) => {
  return css`
    box-sizing: border-box;
    justify-content: space-between;
    padding: 0;
    height: 48px;
    width: 100%;
    min-width: max-content;
    align-items: center;
  `;
});

export const Divider = css(({ theme }) => {
  return css`
    border-bottom: 1px solid #D9DEE8;
  `;
});


export const TableCell = css(({ theme }) => {
  return css`
    font-style: normal;
    font-size: 12px;
    text-align: center;
    padding: 0 10px;

    min-width: 150px;
    color: ${theme.colors.primaryBackground};
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    justify-content: center;
    align-items: center;
  `;
});
